enum ActionType {
    REQUEST_LATEST_EVENTS_TIMESTAMPS = '[CORE/LET] GET LATEST EVENTS TIMESTAMPS',
    RECEIVE_LATEST_EVENTS_TIMESTAMPS = '[CORE/LET] SET LATEST EVENTS TIMESTAMPS',
}

export default ActionType
